import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormAttachmentUploadRequirements } from '../attachments/form-attachment-requirements';
import { parseLocalDate } from '../../../utils/date-time-formatter';

import { GeneralFormData } from '../general-form-data.model';
import { FormStep } from '../form-steps.interface';

export class WeeklySiteInspection  {
    id?: string;
    submittedByName: string = '';
    submittedByEmail: string = '';
    submissionDate?: Date;
    date: Date | null = null;

    // Weekly site inspection specific properties
    jobName: string = '';
    inspector: string = '';
    hazardObserved1: string = '';
    location1: string = '';
    correctiveAction1: string = '';
    upload1: Array<string> = [];
    hazardObserved2: string = '';
    location2: string = '';
    correctiveAction2: string = '';
    upload2: Array<string> = [];
    hazardObserved3: string = '';
    location3: string = '';
    correctiveAction3: string = '';
    upload3: Array<string> = [];
    hazardObserved4: string = '';
    location4: string = '';
    correctiveAction4: string = '';
    upload4: Array<string> = [];

    constructor(data?: Partial<WeeklySiteInspection>) {
          // Set default date to today if not provided
      
          if (data) {
            Object.assign(this, {
                ...data,
            date: data.date ? parseLocalDate(data.date as any) : null,
                submissionDate: data.submissionDate ? new Date(data.submissionDate) : null,
  
            });
        }
    }


    static getFormSteps(): FormStep[] {
        return [
            {
                id: 'basic',
                shortTitle: 'Basic Info',
                title: 'Basic Info',
                icon: 'person-outline',
                description: 'Enter the inspection details and location information',
                sections: [
                    {
                        title: 'Basic Information',
                        fields: ['date', 'jobName', 'inspector']
                    }
                ]
            },
            {
                id: 'hazards',
                shortTitle: 'Hazards',
                title: 'Hazards',
                icon: 'warning-outline',
                description: 'Hazard/Unsafe Act Observed, Location and Corrective Action',
                sections: [
                
                    {
                        title: 'Hazard 1',
                        fields: ['hazardObserved1', 'location1', 'correctiveAction1', 'upload1']
                    },
                    {
                        title: 'Hazard 2',
                        fields: ['hazardObserved2', 'location2', 'correctiveAction2', 'upload2']
                    },
                    {
                        title: 'Hazard 3',
                        fields: ['hazardObserved3', 'location3', 'correctiveAction3', 'upload3']
                    },
                    {
                        title: 'Hazard 4',
                        fields: ['hazardObserved4', 'location4', 'correctiveAction4', 'upload4']
                    }
                ]
            }
        ];
    }

    static getFormInfo(): GeneralFormData {
        return {
            formType: 'weekly-site-inspection',
            formTitle: 'Weekly Site Self Inspection Report',
            formIcon: 'calendar-outline',
            cardImage: 'assets/form-card-tiles/weekly-site-inspection.png',
            formAttachmentRequirements: {
                uploads: [{     
                    identifier: 'upload1',
                    label: this.getFieldMappings()['upload1'],
                    required: 0
                },{
                    identifier: 'upload2',
                    label: this.getFieldMappings()['upload2'],
                    required: 0
                },{
                    identifier: 'upload3',
                    label: this.getFieldMappings()['upload3'],
                    required: 0
                },{
                    identifier: 'upload4',
                    label: this.getFieldMappings()['upload4'],
                    required: 0
                }],
               
            }
        };
    }

    static getFieldMappings(): Record<string, string> {
        return {
            submittedByName: "Submitter Name",
            submittedByEmail: "Submitter Email",
            submissionDate: "Submission Date",
            date: "Date",
            jobName: "Job Name",
            inspector: "Inspector",
            hazardObserved1: "Hazard/Unsafe Act Observed and Location #1",
            location1: "Location #1",
            correctiveAction1: "How was the Hazard or Unsafe Act Corrected? #1",
            hazardObserved2: "Hazard/Unsafe Act Observed and Location #2",
            location2: "Location #2",
            correctiveAction2: "How was the Hazard or Unsafe Act Corrected? #2",
            hazardObserved3: "Hazard/Unsafe Act Observed and Location #3",
            location3: "Location #3",
            correctiveAction3: "How was the Hazard or Unsafe Act Corrected? #3",
            hazardObserved4: "Hazard/Unsafe Act Observed and Location #4",
            location4: "Location #4",
            correctiveAction4: "How was the Hazard or Unsafe Act Corrected? #4",
            upload1: "Hazard 1 Upload",
            upload2: "Hazard 2 Upload",
            upload3: "Hazard 3 Upload",
            upload4: "Hazard 4 Upload",
        };
    }



} 